import React, { memo } from "react";
import { Button, ButtonProps } from "@material-ui/core";
import useAppDashedAddButton from "./index.hooks";
import AddIcon from "@material-ui/icons/Add";
import { AppButton } from "../index";

type AppDashedAddButtonProps = { onClick: any } & ButtonProps;

const AppDashedAddButton = ({ onClick, ...props }: AppDashedAddButtonProps) => {
  const { styles, classes, atomicStyles } = useAppDashedAddButton();

  return (
    <AppButton className={styles.addMerchant} onClick={onClick}>
      <AddIcon className={styles.addIcon} />
    </AppButton>
  );
};

export default memo(AppDashedAddButton);
